import { BodyLong, Heading, Link, VerticalSpace } from '@elhub/ds-components'

import React from 'react'

const SecurePing = () => {
  return (
    <>
      <Heading>Secure ping pong</Heading>
      <VerticalSpace />
      <BodyLong size='small'>
        This endpoint allows to verify the granted access to Elhub protected APIs. Access is granted with a
        valid Maskinporten token (provided as a Bearer token) along with the below header:
      </BodyLong>
      <BodyLong size='small'>X-Elhub-GLN : your-gln-value</BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        <Link variant='primary' href='https://api.elhub.no/data-export/v0/secure-ping'>
          https://api.elhub.no/data-export/v0/secure-ping
        </Link>
      </BodyLong>
    </>
  )
}
export default SecurePing
